module.exports = __webpack_public_path__ + "img/ai5.f6940f07.png";